<template>
	<div class="text-center" v-loading="loading">
		<div class="padding-lr-xl padding-tb">
			<el-avatar :src="userInfo.avatar" :size="cfg.avatarSize" v-if="userInfo.avatar"></el-avatar>
			<el-avatar icon="el-icon-user-solid" :size="cfg.avatarSize" :style="{ 'font-size': cfg.avatarSize * 0.618 + 'px' }" v-else></el-avatar>
		</div>
		<div class="padding-lr-sm padding-bottom flex flex-direction justify-center">
			<div>
				<span class="text-bold text-lg text-blue" v-if="userInfo.gender == 1">{{ userInfo.name }}</span>
				<span class="text-bold text-lg text-pink" v-else-if="userInfo.gender == 2">{{ userInfo.name }}</span>
				<span class="text-bold text-lg" v-else>{{ userInfo.name }}</span>
			</div>
			<div class="padding-tb-xs">
				<span class="cu-tag line-blue round light">{{ userInfo.position }}</span>
			</div>
			<div class="padding-tb-sm">
				<div class="padding-top-xs" v-for="item in userInfo.detps" :key="item.id">
					{{ item.name }}
					<span class="cu-tag line-grey radius sm" v-if="item.is_leader">主管</span>
				</div>
			</div>
		</div>
		<div class="flex justify-between align-center">
			<div class="flex align-center">
				<div class="text-grey">工号</div>
				<div class="text-black margin-left-xs">{{ userInfo.officeid }}</div>
			</div>
			<div>
				<span class="cu-tag light bg-grey round" v-if="userInfo.status == 0">离职</span>
				<span class="cu-tag light bg-olive round" v-else>在职</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'user-card',
	props: {
		visible: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		userId: {
			type: String,
			default: () => {
				return '';
			}
		},
		info: {
			type: Object,
			default: () => {
				return null;
			}
		},
		config: {
			type: Object,
			default: () => {
				return { avatarSize: 128 };
			}
		}
	},
	data() {
		return {
			cfg: {},
			user_id: '',
			userInfo: {},
			isLoadInfo: false,
			loading: true,
			errorMsg: ''
		};
	},
	created: function() {},
	mounted() {
		this.user_id = this.userId;
		this.show = this.visible;
		this.cfg = this.config;
		if (this.info) {
			this.userInfo = this.info;
			this.isLoadInfo = true;
			this.loading = false;
		} else {
			this.userInfo = {
				user_id: '',
				avatar: '',
				name: '姓名',
				position: '职务',
				officeid: '1024',
				status: 1,
				detps: []
			};
		}
		if (this.visible) {
			this.showUserInfo();
		}
	},
	methods: {
		showUserInfo() {
			if (!this.isLoadInfo && this.show) {
				this.loading = true;
				this.$http.post('/server/index.php?m=components/userCard&a=getInfo', { id: this.user_id }).then(
					res => {
						this.loading = false;
						if (res.result == 'ok') {
							this.userInfo = res.data;
							this.isLoadInfo = true;
						}
					},
					r => {
						this.loading = false;
					}
				);
			}
		}
	},
	watch: {
		info: function(val) {
			this.userInfo = val;
			this.loading = false;
		},
		visible: function(val) {
			this.show = val;
			this.showUserInfo();
		},
		userId: function(val) {
			this.user_id = val;
			this.isLoadInfo = false;
			this.userInfo = {
				user_id: '',
				avatar: '',
				name: '姓名',
				position: '职务',
				officeid: '1024',
				status: 1,
				detps: []
			};
		}
	}
};
</script>

<style>
.infoshow-list {
	display: flex;
	justify-content: space-between;
}
</style>
